<div *ngIf="loader" class="flex items-center justify-center min-h-screen bg-slate-50">
  <div class="flex flex-col items-center">
    <img src="/assets/img/spinner.gif" class="h-32">
  </div>
</div>
